export enum EventsFlowEventNodeTypes {
  OnCallDetailRecord = 'on-call-detail-record',
  OnRecordingAvailable = 'on-recording-available',
  OnNewCallIncoming = 'on-new-call-incoming',
  OnConnectToAgent = 'on-connect-to-agent',
}

export const hasEventsFlowEventNodeTypes = (value: any): value is EventsFlowEventNodeTypes => {
  return Object.values(EventsFlowEventNodeTypes).includes(value);
};
